import script from "./detailDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./detailDialog.vue?vue&type=script&lang=ts&setup=true"

import "./detailDialog.vue?vue&type=style&index=0&id=97f68db4&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97f68db4"]])

export default __exports__